import { UploadIcon } from '@avila-tek/ui/src';
import React from 'react';
import { useDropzone, FileRejection, DropEvent, Accept } from 'react-dropzone';

// https://blog.logrocket.com/drag-and-drop-in-react/

interface DropZoneProps {
  accept?: Accept;
  className?: string;
  text?: string;
  onDrop?: <T extends File>(
    acceptedFiles: T[],
    fileRejections?: FileRejection[],
    event?: DropEvent
  ) => void;
}

export default function DropZone({
  onDrop,
  className = 'w-full h-28',
  accept,
  text = 'Arrastre las imágenes o haga click acá para buscarlas',
}: DropZoneProps) {
  const { getRootProps, getInputProps, isDragActive, acceptedFiles } =
    useDropzone({
      onDrop,
      accept,
    });
  return (
    <div
      {...getRootProps()}
      className={`
      ${className} rounded border-2 flex cursor-pointer ${
        isDragActive
          ? 'bg-gray-100 border-neutral-400  border-solid'
          : 'bg-gray-50 border-neutral-300  border-dashed'
      }
      `}
      role="button"
    >
      <input className="dropzone-input" {...getInputProps()} />
      <div className="text-center my-auto text-cool-gray-600 w-full">
        <UploadIcon className="w-5 h-5 text-center m-auto mb-2" />
        {isDragActive ? (
          <p className="text-center text-2base">Arrastre las imágenes</p>
        ) : (
          <p className="text-center text-2base mx-6">{text}</p>
        )}
      </div>
    </div>
  );
}
